import {
  ADD_COMPANY,
  UPDATE_COMPANY,
  SET_COMPANIES,
  SET_SELECTED_COMPANY,
  UPDATE_COMPANY_NAME,
  DELETE_COMPANY,
} from "../types/company";

const initialState = {
  selected_company: {},
  companies: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ADD_COMPANY:
      return {
        ...state,
        companies: [payload, ...state.companies],
      };
      break;
    case UPDATE_COMPANY:
      let companies = state.companies.filter((company) => company.id !== payload.id);
      return {
        ...state,
        companies: [payload, ...companies],
      };
      break;
    case UPDATE_COMPANY_NAME:
      let company = state.companies.filter((company) => company.id === payload.id)[0];
      company.company_name = payload.company_name;
      company.shared = payload.shared;
      state.selected_company = company;
      return {
        ...state,
        selected_company: { ...company },
        companies: [...state.companies],
      };
    case DELETE_COMPANY:
      let newCompanies = state.companies.filter((company) => company.id !== payload);
      if (state.selected_company.id === payload) {
        if (newCompanies.length > 0) {
          localStorage.setItem("selected_company", newCompanies[0]?.id);
          state.selected_company = newCompanies[0];
        } else {
          localStorage.removeItem("selected_company");
          state.selected_company = {};
        }
      }
      return {
        ...state,
        companies: [...newCompanies],
      };
      break;
    case SET_COMPANIES:
      return {
        ...state,
        companies: payload,
      };
      break;
    case SET_SELECTED_COMPANY:
      localStorage.setItem("selected_company", payload.id);
      return {
        ...state,
        selected_company: payload,
      };
      break;
    default:
      return state;
  }
};

export default reducer;
